import { i18n } from '@ecg-internal/js-react-i18n';
import { nl as dateLocale } from 'date-fns/locale/nl';
import translation from '../../../../locales/nl-BE/translation.json';
import common from '../../../../locales/nl-BE/common.json';
import reviewsDialogUi from '@ecg-internal/reviews-dialog-ui/locales/nl-BE.json';

export default i18n.init({
  lng: 'nl-BE',
  translation,
  dateLocale,
  translations: {
    translation,
    common,
    reviewsDialogUi,
  },
});
